import { useTranslation } from 'react-i18next'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
  Button,
  Card,
  CardHeader,
  CardTitle,
} from '@clouway/ui'
import type { ConfigTemplate } from '@/features/configTemplates'

export function TemplateApplyCard({
  template,
  onConfirm,
}: {
  template: ConfigTemplate
  onConfirm: (template: ConfigTemplate) => void
}) {
  const { t } = useTranslation('feature')

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between gap-2">
          <div>
            <CardTitle className="text-sm">{template.name}</CardTitle>
            <p className="text-muted-foreground text-sm">{template.device.modelName}</p>
          </div>
          <AlertDialog>
            <AlertDialogTrigger asChild>
              <Button variant="outline" size="sm">
                {t('trackingObjects.config.useTemplate')}
              </Button>
            </AlertDialogTrigger>
            <AlertDialogContent>
              <AlertDialogHeader>
                <AlertDialogTitle>
                  {t('trackingObjects.config.useTemplateComfirmTitle', { name: template.name })}
                </AlertDialogTitle>
                <AlertDialogDescription>{t('trackingObjects.config.confirmMessage')}</AlertDialogDescription>
              </AlertDialogHeader>
              <AlertDialogFooter>
                <AlertDialogCancel>{t('trackingObjects.config.useTemplate')}</AlertDialogCancel>
                <AlertDialogAction onClick={() => onConfirm(template)}>
                  {t('trackingObjects.config.useTemplate')}
                </AlertDialogAction>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialog>
        </div>
      </CardHeader>
    </Card>
  )
}
